import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// import SpaceViewer from "./SpaceViewer";
// import MezzanineFloorViewer from './MezzanineFloorViewer'; 
// import SecondFloorViewer from './SecondFloorViewer'; 
// import ThirdFloorViewer from './ThirdFloorViewer';
// import LLR from "./LRR";
// import MFloorViewer from "./MfloorZoom";
import FirstViewer from "./FirstViewer";
import SecondViewer from "./SecondViewer";
import ThirdViewer from "./ThirdViewer";
import MFViewer from "./MFViewer";
import LRRViewer from "./LRRViewer";
import MFZoomViewer from "./MFZoomViewer";


const App = () => {
  return (
    <BrowserRouter>
      <Routes>
     
        {/* <Route path="/" element={<SpaceViewer />} />
        <Route path="/first-floor" element={<SpaceViewer />} />
        <Route path="/m-floor" element={<MezzanineFloorViewer />} />
        <Route path="/second-floor" element={<SecondFloorViewer />} />
        <Route path="/third-floor" element={<ThirdFloorViewer />} />
        <Route path="/lrr" element={<LLR />} />
        <Route path="/mfc" element={<MFloorViewer />} /> */}
        {/* <Route path="/test" element={<SpaceViewer1 />} /> */}

        <Route path="/" element={<FirstViewer />} />
        <Route path="/test1" element={<FirstViewer />} />
        <Route path="/test-mf" element={<MFViewer />} />
        <Route path="/test2" element={<SecondViewer />} />
        <Route path="/test3" element={<ThirdViewer />} />
        <Route path="/test-lrr" element={<LRRViewer />} />
        <Route path="/test-mfc" element={<MFZoomViewer />} />


      


      </Routes>
    </BrowserRouter>
  );
};

export default App;